import { Button, Grid } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { trackPromise } from 'react-promise-tracker';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { onError, onSuccess } from 'src/store/actions/popupActions';
import axios from '../../axios/AxiosInterceptors';
import useStyles from "../../Styles";
import GeneratorComponent from './GeneratorComponent';

const ViewGenerator = (props) => {

    const classes = useStyles();
    const history = useHistory();
    const params = useParams();
    const dispatch = useDispatch();
    const [isEdit, setIsEdit] = useState(false);
    const [generator, setGenerator] = useState({});

    useEffect(() => {
        retrieveGenerator();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params.accountId, params.generatorId]);

    const retrieveGenerator = async () => {
        await trackPromise(axios.get("/account-service/v1/account/" + params.accountId + "/generator/" + params.generatorId).then(response => {
            setGenerator(response.data);
        }).catch(error => {
            dispatch(onError(error.response));
        }))
    }

    const handleSave = async () => {
        await trackPromise(axios.put("/account-service/v1/account/" + params.accountId + "/generator/" + params.generatorId, JSON.stringify(generator)).then(response => {
            dispatch(onSuccess("Successfully saved generator"));
            history.push("/generator-management/account/" + params.accountId + "/generator")
        }).catch(error => {
            dispatch(onError(error.response));
        }));
    }

    const updateGenerator = (generator) => {
        setGenerator({ ...generator });
    }

    const onEditClick = () => {
        setIsEdit(true);
    }

    return (
        <main className={classes.layout}>
            <GeneratorComponent generator={generator} onChange={updateGenerator} isEdit={isEdit} />
            <Grid container spacing={2}>
                <Grid item xs={6} sm={2} />
                <Grid item xs={6} sm={2}>
                    <Button onClick={() => history.goBack()}>Back</Button>
                </Grid>
                <Grid item xs={6} sm={2} />
                <Grid item xs={6} sm={2}>
                    <Button onClick={onEditClick}>Edit</Button>
                </Grid>
                <Grid item xs={6} sm={2} />
                <Grid item xs={6} sm={2}>
                    <Button onClick={handleSave} disabled={!isEdit}>Save</Button>
                </Grid>
            </Grid>
        </main>
    )

}

export default ViewGenerator;